import { NgModule } from '@angular/core';
import { AreaImageModule } from './AreaImageComponent/areaImage.module';
import { BreadcrumbModule } from './BreadcrumbComponent/breadcrumb.module';
import { ButtonModule } from './ButtonComponent/button.module';
import { CheckboxModule } from './CheckboxComponent/checkbox.module';
import { FormButtonModule } from './FormButtonComponent/formButton.module';
import { HeadingModule } from './HeadingComponent/heading.module';
import { InputFormGroupModule } from './InputFormGroupComponent/inputFormGroup.module';
import { InputModule } from './InputComponent/input.module';
import { LinkModule } from './LinkComponent/link.module';
import { ModalModule } from './ModalComponent/modal.module';
import { NotFoundModule } from '@common/components/NotFoundComponent/notFound.module';
import { ProgressIndicatorModule } from './ProgressIndicatorComponent/progressIndicator.module';
import { RadioModule } from './RadioComponent/radio.module';
import { SortableTableModule } from './SortableTableComponent/sortableTable.module';
import { WelcomeModule } from './WelcomeComponent/welcome.module';

@NgModule({
  imports: [
    AreaImageModule,
    BreadcrumbModule,
    ButtonModule,
    CheckboxModule,
    FormButtonModule,
    HeadingModule,
    InputFormGroupModule,
    InputModule,
    LinkModule,
    ModalModule,
    NotFoundModule,
    RadioModule,
    SortableTableModule,
    WelcomeModule,
  ],
  exports: [
    AreaImageModule,
    BreadcrumbModule,
    ButtonModule,
    CheckboxModule,
    FormButtonModule,
    HeadingModule,
    InputFormGroupModule,
    InputModule,
    LinkModule,
    ModalModule,
    NotFoundModule,
    ProgressIndicatorModule,
    RadioModule,
    SortableTableModule,
    WelcomeModule,
  ],
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/common/components/components.module.ts